import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import Cookies from 'js-cookie';

const UnprotectedRoute = ({ component: Component, ...rest }) => {
    
    const authUser = Cookies.get('authUser');
    
    return (
        <Route {...rest} render={ 
            props => {
                if (!authUser) {
                    return <Component {...rest} {...props} />
                } else {
                    return <Redirect to={
                        {
                            pathname: '/dashboard',
                            state: { from: props.location }
                        }
                    } />
                }    
            }
        } />      
    )
}

export default UnprotectedRoute;